import PyramidAuthors from './PyramidAuthors';

export default PyramidAuthors;
